import { render } from "./WalletComponent.vue?vue&type=template&id=3e10c736"
import script from "./WalletComponent.vue?vue&type=script&lang=js"
export * from "./WalletComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__